export var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["None"] = "none";
    SubscriptionType["Base"] = "base";
    SubscriptionType["Features"] = "features";
})(SubscriptionType || (SubscriptionType = {}));
